import { OWL } from "../sgov-vocabulary.js";
export async function loadSgovCardinalities(rdfEntity, pimResource) {
    const min = await rdfEntity.property(OWL.minQualifiedCardinality);
    if (min.length > 0) {
        pimResource.pimCardinalityMin = Number(min[0].value);
    }
    const max = await rdfEntity.property(OWL.maxQualifiedCardinality);
    if (max.length > 0) {
        pimResource.pimCardinalityMax = Number(max[0].value);
    }
}
//# sourceMappingURL=sgov-resource-cardinality-adapter.js.map